var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortfolioLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_3277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.627 28.5H9.03516V13.3438H11.0176L14.5137 23.3242L18.0098 13.3438H19.9434V28.5H18.127V18.8418L18.1758 17.5137H18.127L17.6973 18.8418L15.3535 25.4727H13.3809L11.0078 18.8418L10.627 17.5137H10.5781L10.627 18.8418V28.5ZM25.5098 28.5V15.0137H20.9688V13.3438H32.0332V15.0137H27.4824V28.5H25.5098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 20.5V0.5H40.5V40.5H20.5",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_3277)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -11.5,
    width: 64,
    height: 64,
    fill: "url(#paint0_linear_170_3277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_3277",
    x1: 20.5,
    y1: -11.5,
    x2: 20.5,
    y2: 52.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0721154,
    stopColor: "#015C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536058,
    stopColor: "#00AA9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F9D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioLogo);
export default __webpack_public_path__ + "static/media/portfolio-logo.fcc7684416375054cca003d0862fbc6f.svg";
export { ForwardRef as ReactComponent };